<footer [class]="footerClassName">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6">
                DeGarmo © {{year}} v{{ version }}
            </div>
            <div class="col-sm-6">
                <div class="text-sm-end d-none d-sm-block">
                </div>
            </div>
        </div>
    </div>
</footer>
